export function exportToJSON(scores, profile, includeNotes = false) {
    const data = {
        profile,
        results: scores,
        exportedAt: new Date().toISOString(),
        version: '1.0.0',
    };
    return new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
}
export function exportToCSV(scores) {
    const headers = ['Modelo', 'IMN', 'IAP', 'ICP', 'IRD', 'IEN', 'SFP'];
    const rows = scores.map(s => [
        s.modelId,
        s.indices.imn.toFixed(2),
        s.indices.iap.toFixed(2),
        s.indices.icp.toFixed(2),
        s.indices.ird.toFixed(2),
        s.indices.ien.toFixed(2),
        s.sfp.toFixed(2),
    ]);
    const csvContent = [headers, ...rows]
        .map(r => r.map(v => `"${v}"`).join(','))
        .join('\n');
    return new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
}
export function exportToPDF(scores, profile) {
    const printWindow = window.open('', '_blank');
    if (!printWindow)
        return;
    const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>DecidePro - Relatório de Avaliação</title>
      <style>
        body { font-family: Inter, sans-serif; background: #0a0a0f; color: #f1f5f9; }
        .container { max-width: 800px; margin: 40px auto; padding: 20px; }
        h1 { color: #6366f1; border-bottom: 1px solid rgba(255,255,255,0.1); }
        h2 { color: #a855f7; margin-top: 24px; }
        table { width: 100%; border-collapse: collapse; margin: 16px 0; }
        th, td { padding: 8px 12px; text-align: left; border-bottom: 1px solid rgba(255,255,255,0.1); }
        th { background: rgba(99,102,241,0.1); color: #6366f1; }
        .score { font-weight: bold; }
        .score-high { color: #22c55e; }
        .score-medium { color: #f59e0b; }
        .score-low { color: #ef4444; }
      </style>
    </head>
    <body>
      <div class="container">
        <h1>DecidePro - Relatório de Avaliação</h1>
        <p>Perfil: ${profile?.name || 'Não definido'} | Gerado: ${new Date().toLocaleString('pt-BR')}</p>
        <table>
          <thead><tr><th>#</th><th>Modelo</th><th>IMN</th><th>IAP</th><th>ICP</th><th>IRD</th><th>IEN</th><th>SFP</th></tr></thead>
          <tbody>
            ${scores.map((s, i) => {
        const rankClass = i === 0 ? 'score-high' : i <= 2 ? 'score-medium' : 'score-low';
        return `<tr><td>${i + 1}º</td><td>${s.modelId}</td><td>${s.indices.imn.toFixed(1)}</td><td>${s.indices.iap.toFixed(1)}</td><td>${s.indices.icp.toFixed(1)}</td><td>${s.indices.ird.toFixed(1)}</td><td>${s.indices.ien.toFixed(1)}</td><td class="score ${rankClass}">${s.sfp.toFixed(1)}</td></tr>`;
    }).join('')}
          </tbody>
        </table>
      </div>
    </body>
    </html>
  `;
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
}
